import Icon from "@ant-design/icons";

const SVG = () => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" fill="currentColor">
    <title></title>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 4C2 3.44772 2.44772 3 3 3H16C16.5523 3 17 3.44772 17 4C17 4.55228 16.5523 5 16 5H3C2.44772 5 2 4.55228 2 4ZM2 8C2 7.44772 2.44772 7 3 7H12C12.5523 7 13 7.44772 13 8C13 8.55228 12.5523 9 12 9H3C2.44772 9 2 8.55228 2 8ZM17.3828 7.07588C17.4999 7.12432 17.6096 7.19595 17.705 7.29078C17.7057 7.29148 17.7064 7.29219 17.7071 7.29289C17.7073 7.29305 17.7074 7.2932 17.7076 7.29336L21.7071 11.2929C22.0976 11.6834 22.0976 12.3166 21.7071 12.7071C21.3166 13.0976 20.6834 13.0976 20.2929 12.7071L18 10.4142V20C18 20.5523 17.5523 21 17 21C16.4477 21 16 20.5523 16 20V10.4142L13.7071 12.7071C13.3166 13.0976 12.6834 13.0976 12.2929 12.7071C11.9024 12.3166 11.9024 11.6834 12.2929 11.2929L16.2924 7.29336C16.2926 7.2932 16.2927 7.29305 16.2929 7.29289C16.2936 7.29219 16.2943 7.29148 16.295 7.29078C16.3904 7.19595 16.5001 7.12432 16.6172 7.07588C16.7351 7.02699 16.8644 7 17 7C17.1356 7 17.2649 7.02699 17.3828 7.07588ZM2 12C2 11.4477 2.44772 11 3 11H9C9.55228 11 10 11.4477 10 12C10 12.5523 9.55228 13 9 13H3C2.44772 13 2 12.5523 2 12Z"
    />
  </svg>
);

const SortAscendingIcon = (props) => <Icon component={SVG} {...props} />;

export default SortAscendingIcon;
